<template>
    <div>
        <audio-player></audio-player>
    </div>
</template>
<script>
import audioPlayer from '@/components/contents/parentingAudio/parentingAudio_1.0'
export default {
    data(){
        return{

        }
    },
    components:{
        audioPlayer
    }
}
</script>